angular.module("app").service("cropperService", [
    'Cropper',
    '$timeout',
    'uploadImageParams',
    'logger',
    'Utils',
    function (Cropper, $timeout, uploadImageParams, logger, Utils) {
        return function () {
            var scope = this,
                watchers = [],
                file,
                data,
                pagePristineImageDataUri;

            var _self = this;

            var cropCalledCount = 0;
            this.calledCount = 0;

            this.cropper = {};
            this.cropperProxy = 'cropper.first';
            this.options = {
                maximize: true,
                autoCrop: false,
                crop: function(dataNew) {
                    data = dataNew;
                    if (!_self.cropped && cropCalledCount > 3 && data && data.width && data.height) {
                        _self.cropped = true;
                        if (_self) {
                           $timeout(function () {
                              _self.$apply();
                           });
                        }
                    }
                    cropCalledCount++;

                }
            };
            this.showEvent = 'show';
            this.hideEvent = 'hide';

            this.load = function (file, fileDataUrl) {
                $timeout(function () {
                        ++scope.calledCount;
                        scope.draggedImage = file;
                        scope.draggedImageDataUrl = fileDataUrl;
                        pagePristineImageDataUri = fileDataUrl;
                        scope.imageDeleted = false;
                        cropCalledCount = 0;
                })
            };

            this.onFile = function (file) {
                $timeout(function () {
                    if (file.size > uploadImageParams.imageSiza) {
                        var fileSizeConvert = file.size / 1048576;
                        logger.logError("Max file size is 4MB. Your file is " + ' ' + fileSizeConvert.toFixed(2) + 'MB');
                    }else {
                        switch(scope.imageTypes) {
                            case ".ico,.png": {
                                if (file.type.indexOf('png') === -1 && file.type.indexOf('x-icon') === -1) {
                                    return;
                                }
                                break;
                            }
                            case ".png": {
                                if (file.type.indexOf('png') === -1) {
                                    return;
                                }
                                break;
                            }
                            default: {
                                if(file.type.indexOf('png') === -1 && file.type.indexOf('jpg') === -1 &&  file.type.indexOf('gif') === -1 && file.type.indexOf('jpeg') === -1 ) {
                                    return;
                                }
                            }
                        }
                        scope.calledCount = 2;
                        scope.draggedImage = file;
                        scope.imageDeleted = false;
                    }

                })
            };

            this.preview = function(cb) {
                if (!file || !data || !data.width || !data.height) {
                    if (scope.dataUrl) {
                        return cb(Utils.fixImageBase64URL(file, scope.dataUrl));
                    } else {
                        return cb();
                    }
                }
                Cropper.crop(file, data).then(Cropper.encode).then(function(dataUrl) {
                    cb(Utils.fixImageBase64URL(file, dataUrl));
                });
            };

            this.clear = function(degrees) {
                if (!scope.cropper.first) return;
                scope.cropper.first('clear');
            };

            this.scale = function(width) {
                Cropper.crop(file, data)
                    .then(function(blob) {
                        return Cropper.scale(blob, {width: width});
                    })
                    .then(Cropper.encode).then(function(dataUrl) {
                        (scope.preview || (scope.preview = {})).dataUrl = dataUrl;
                    });
            };

            this.$on("$destroy", function () {
                    var i = 0;
                    while(watchers[i]) {
                        watchers[i]();
                        i++;
                    }
                });

            function handleImageLoad (newVal) {
                $timeout(function () {
                    hideCropper();
                    scope.imageDeleted = false;
                    Cropper.encode((file = newVal)).then(function (dataUrl) {
                        scope.newImageUploaded =(pagePristineImageDataUri != dataUrl);
                        scope.dataUrl = dataUrl;
                        $timeout(showCropper);  // wait for $digest to set image's src
                    });
                }, 24)
            }

            function showCropper() { scope.$broadcast(scope.showEvent); }

            function hideCropper() { scope.$broadcast(scope.hideEvent); }

            watchers.push(scope.$watch('draggedImage', function (newVal) {
                if (!!newVal) {
                    Utils.checkFileAndMakeWarning(scope.draggedImage, logger);

                    if (scope.draggedImage.size > uploadImageParams.imageSiza) {
                        var fileSizeConvert = scope.draggedImage.size / 1048576;
                        logger.logError("Max file size is 4MB. Your file is " + ' ' + fileSizeConvert.toFixed(2) + 'MB');
                        scope.draggedImage = undefined;
                    } else {
                        handleImageLoad(newVal);

                    }
                } else {
                    data =  newVal
                }
            }));
        }
    }
]);






